'use client'
import { useEffect, useRef } from 'react'

import { init } from '../core/client'
import type { AnalyticsProps } from '../core/types'

export function Analytics(props: AnalyticsProps) {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current || props.disabled) {
      return
    }
    initialized.current = true

    const client = init({
      endpoint: props.endpoint,
      apiKey: props.apiKey,
      debug: props.debug,
      disabled: props.disabled,
      beforeSend: props.beforeSend,
      onError: props.onError,
    })

    return () => {
      void client.close()
    }
  }, [])

  return null
}
